import _ from 'lodash';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { ModalLoginService } from '../modal-login/modal-login.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NavMenuService {
    public navMenu = [{
        id: "toggle",
        access: [1,2,3,4],
        link: {
            id: "toggleA",
            icon: "sv-slim-icon fas fa-angle-double-left",
            label: "Collapse Menu",
            onClick: () => {},
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "waves-effect": true,
                "disabled": false,
                "grey-text": false,
            },
            ngStyle: {
                color: '#f3da1f'
            }
        },
        children: []
    }, {
        id: "sideMenuDashboard",
        access: [1,2,3,4],
        link: {
            id: "sideMenuDashboardA",
            icon: "sv-slim-icon fas fa-home",
            label: "Dashboard",
            onClick: () => {
                this.navigateByUrl('/dashboard')
            },
            routerLink: '/dashboard',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "sideMenuAccount",
        access: [1,2,3,4], //change only admin
        link: {
            id: "sideMenuAccountA",
            icon: "sv-slim-icon fas fa-user-edit",
            label: "Account",
            onClick: () => {
                this.navigateByUrl('/account')
            },
            routerLink: '/account',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "sideMenuPP",
        access: [1,2],
        link: {
            id: "sideMenuPPA",
            icon: "sv-slim-icon fas fa-qrcode",
            label: "Campaigns",
            onClick: () => {
                this.navigateByUrl('/campaign')
            },
            routerLink: '/campaign',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "managePage",
        access: [1,2,3,4],
        link: {
            id: "managePageA",
            icon: "sv-slim-icon fas fa-users-cog",
            label: "Manage",
            onClick: () => {},
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: { exact: false },
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "arrow-r": true,
                "side-nav-sub-item-background": true,
                "itemAccordion": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: [{
            id: "sideMenuEvent",
            access: [1,3],
            link: {
                id: "sideMenuEventA",
                icon: "sv-slim-icon fas fa-calendar-day fa-angle-double-left",
                label: "Events",
                onClick: () => {
                    this.navigateByUrl('/event')
                },
                routerLink: '/event',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        }, {
            id: "sideMenuTicketing",
            access: [1,2],
            link: {
                id: "sideMenuTicketingA",
                icon: "fas fa-ticket-alt",
                label: "Tickets and Guests",
                onClick: () => {
                    this.navigateByUrl('/manage/tickets-and-guests')
                },
                routerLink: '/manage/tickets-and-guests',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        },
        {
            id: "sideMenuMerchandise",
            access: [1,2],
            link: {
                id: "sideMenuMerchandiseA",
                icon: "fas fa-store",
                label: "Merchandise",
                onClick: () => {
                    this.navigateByUrl('/manage/merchandise')
                },
                routerLink: '/manage/merchandise',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        },
        {
            id: "sideMenuPartySignup",
            access: [1,2],
            link: {
                id: "sideMenuPartySignupA",
                icon: "fas fa-clipboard-list",
                label: "Party Signup",
                onClick: () => {
                    this.navigateByUrl('/manage/party-signup')
                },
                routerLink: '/manage/party-signup',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        },
         {
            id: "sideMenuAuction",
            access: [1,2],
            link: {
                id: "sideMenuAuctionA",
                icon: "fas fa-gavel",
                label: "Auctions",
                onClick: () => {
                    this.navigateByUrl('/manageAuction')
                },
                routerLink: '/manageAuction',
                routerLinkActive: "active",
                routerLinkActiveOptions: { },
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        }, {
            id: "sideMenuP2PReport",
            access: [1,2],
            link: {
                id: "sideMenuP2PReportA",
                icon: "sv-slim-icon fas fa-users",
                label: "Peer To Peer",
                onClick: () => {
                    this.navigateByUrl('/manage/p2p')
                },
                routerLink: '/manage/p2p',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        }, {
            id: "sideMenuStreaming",
            access: [1,3],
            link: {
                id: "sideMenuStreamingA",
                icon: "sv-slim-icon fas fa-video",
                label: "Live Streaming",
                onClick: () => {
                    this.navigateByUrl('/streaming')
                },
                routerLink: '/streaming',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        }]
    }, {
        id: "integrationsPage",
        access: [1],
        show: false,
        link: {
            id: "integrationsPageA",
            icon: "sv-slim-icon fas fa-users-cog",
            label: "Integrations",
            onClick: () => {},
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: { exact: false },
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "arrow-r": true,
                "side-nav-sub-item-background": true,
                "itemAccordion": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: [{
            id: "sideMenuMonkey",
            access: [1],
            link: {
                id: "sideMenuMonkeyA",
                icon: "sv-slim-icon fas fa-users-cog",
                label: "Webhook",
                onClick: () => {
                    this.navigateByUrl('/integration/web-hook')
                },
                routerLink: '/integration/web-hook',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        }]
    }, {
        id: "sideMenuAnalytics",
        access: [1,2,3,4],
        link: {
            id: "sideMenuAnalyticsA",
            icon: "sv-slim-icon fas fa-chart-area",
            label: "Reports",
            onClick: () => {},
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: { exact: false },
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "arrow-r": true,
                "side-nav-sub-item-background": true,
                "itemAccordion": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: [{
        id: "sideMenuTransfers",
        access: [1,4],
        link: {
            id: "sideMenuTransfersA",
            icon: "sv-slim-icon fas fa-university",
            label: "Transfers",
            onClick: () => {
                this.navigateByUrl('/reportTransfers')
            },
            routerLink: '/reportTransfers',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }, {
        id: "sideMenuAll",
        access: [1,2,4],
        link: {
            id: "sideMenuAllA",
            icon: "sv-slim-icon far fa-chart-bar",
            label: "All Donations",
            onClick: () => {
                this.navigateByUrl('/reportAll')
            },
            routerLink: '/reportAll',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        } 
        }, {
            id: "reportPendingCarts",
            access: [1,3,4],
            link: {
                id: "reportPendingCartsA",
                icon: "sv-slim-icon fas fa-shopping-cart",
                label: "All Pending",
                onClick: () => {
                    this.router.navigate(['/reportPendingCarts'], { fragment: 'cartsTab' })
                },
                routerLink: '/reportPendingCarts',
                routerLinkActive: "active",
                routerLinkActiveOptions: {},
                ngClass: {
                    "collapsible-header": true,
                    "waves-effect": true,
                    "disabled": false,
                    "grey-text": false
                },
                ngStyle: {}
            }
        }, {
        id: "sideMenuCampaigns",
        access: [1,2,4],
        link: {
            id: "sideMenuCampaignsA",
            icon: "sv-slim-icon fas fa-qrcode",
            label: "Campaigns",
            onClick: () => {
                this.navigateByUrl('/reports/campaign')
            },
            routerLink: '/reports/campaign',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }, {
        id: "sideMenuDonors",
        access: [1,4],
        link: {
            id: "sideMenuDonorsA",
            icon: "sv-slim-icon fas fa-user",
            label: "Donors",
            onClick: () => {
                this.navigateByUrl('/reportDonors')
            },
            routerLink: '/reportDonors',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }, {
        id: "sideMenuRecurring",
        access: [1,4],
        link: {
            id: "sideMenuRecurringA",
            icon: "sv-slim-icon far fa-calendar-check",
            label: "Recurring",
            onClick: () => {
                this.navigateByUrl('/reportRecurring')
            },
            routerLink: '/reportRecurring',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }, {
        id: "sideMenuUnsettled",
        access: [1,4],
        link: {
            id: "sideMenuUnsettledA",
            icon: "sv-slim-icon fas fa-money-bill",
            label: "Unsettled Donations",
            onClick: () => {
                this.navigateByUrl('/reportUnsettled')
            },
            routerLink: '/reportUnsettled',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }, {
        id: "sideMenuMatching",
        access: [1,4],
        link: {
            id: "sideMenuMatching",
            icon: "sv-slim-icon far fa-building",
            label: "Matching",
            onClick: () => {
                this.navigateByUrl('/reportMatching')
            },
            routerLink: '/reportMatching',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }]
    }, {
        id: "sideMenuVolunteers",
        access: [1,2,3,4], //change only admin
        link: {
            id: "sideMenuVolunteersA",
            icon: "sv-slim-icon fas fa-users",
            label: "Volunteers",
            onClick: () => {
                this.navigateByUrl('/volunteers')
                window['$']("#slide-out").scrollTop(0)
            },
            routerLink: '/volunteers',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "sideMenuAccounts",
        access: [1,2,3,4], //change only admin
        link: {
            id: "sideMenuAccountsA",
            icon: "sv-slim-icon fas fa-user-plus",
            label: "Users",
            onClick: () => {
                this.navigateByUrl('/users')
                window['$']("#slide-out").scrollTop(0)
            },
            routerLink: '/users',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "sideMenuOffline",
        access: [1,2,3,4],
        link: {
            id: "sideMenuOfflineA",
            icon: "sv-slim-icon fas fa-archive",
            label: "Add Donations",
            onClick: () => {
                window['$']("#slide-out").scrollTop(0)
            },
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: { exact: false },
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "arrow-r": true,
                "side-nav-sub-item-background": true,
                "itemAccordion": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: [{
        id: "sideMenuOfflineOne",
        access: [1,2],
        link: {
            id: "sideMenuOfflineOneA",
            icon: "sv-slim-icon far fa-edit",
            label: "One By One",
            onClick: () => {
                this.navigateByUrl('/offlineOne')
            },
            routerLink: '/offlineOne',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }, {
        id: "sideMenuOfflineBulk",
        access: [1,2],
        link: {
            id: "sideMenuOfflineBulkA",
            icon: "sv-slim-icon far fa-file-excel",
            label: "Bulk",
            onClick: () => {
                this.navigateByUrl('/offlineBulk')
            },
            routerLink: '/offlineBulk',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        }
        }]
    }, {
        id: "sideMenuHelp",
        access: [1,2,3,4],
        link: {
            id: "sideMenuHelpA",
            icon: "sv-slim-icon fas fa-question-circle",
            label: "Help",
            onClick: () => {
                window['$']("#slide-out").scrollTop(0)
                window.open(
                'https://docs.paybee.io',
                '_blank'
                );
            },
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "sideMenuLegal",
        access: [1,2,3,4],
        link: {
            id: "sideMenuLegalA",
            icon: "sv-slim-icon fas fa-gavel",
            label: "Legal",
            onClick: () => {
                this.navigateByUrl('/legal')
                window['$']("#slide-out").scrollTop(0)
            },
            routerLink: '/legal',
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: {}
        },
        children: []
    }, {
        id: "sideMenuLogout",
        access: [1,2,3,4],
        link: {
            id: "sideMenuLogoutA",
            icon: "sv-slim-icon fas fa-sign-out-alt",
            label: "Logout",
            onClick: () => {
                this.logout();
            },
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "collapsible-header": true,
                "waves-effect": true,
                "disabled": false,
                "grey-text": false
            },
            ngStyle: { color: "#dc9292" }
        },
        children: []
    }]

    public orgNavMenu = [{
        id: "switch",
        access: [1,2,3,4],
        link: {
            id: "switchA",
            icon: "sv-slim-icon fas fa-user-cog",
            label: `Switch Organization`,
            onClick: () => {},
            routerLink: null,
            routerLinkActive: "active",
            routerLinkActiveOptions: {},
            ngClass: {
                "waves-effect": true,
                "disabled": false,
                "grey-text": false,
            }
        },
        hide: false,
        children: []
    }]

    constructor(
        public router: Router,
        private cookieService: CookieService,
        private modalLoginService: ModalLoginService,
        private authService: AuthService
    ) {}

    navigateByUrl(url: string) {
        return this.router.navigateByUrl(url);
    }

    logout() {
        const orgSignIn = window['orgSignIn'];
    
        clearInterval(orgSignIn.accessTokenTimerId);
        orgSignIn.accessTokenTimerId = -1;
    
        clearInterval(orgSignIn.adminAccessTokenTimerId);
        orgSignIn.adminAccessTokenTimerId = -1;
    
        this.cookieService.delete('accessToken', '/');
        this.cookieService.delete('adminAccessToken', '/');
    
        this.authService.reset();
    
        const moddalRef = this.modalLoginService.open();
        moddalRef.onClose.pipe(
          first()
        ).subscribe(() => {
          this.modalLoginService.modalRef = null;
          this.navigateByUrl(this.router.url);
        });
      }
}
